import { decryptText, encryptText } from "./Encryption";

const updateUserStates = (setUserData, setUserToken) => {
  const localStorageItems = localStorage;
  const obj = {};

  if (localStorageItems.length !== 0) {
    for (let key in localStorageItems) {
      try {
        const decryptedKey = decryptText(key);

        if (localStorageItems[key] && decryptedKey === "user") {
          console.log("👤 User found in localStorage");

          obj.user = JSON.parse(decryptText(localStorageItems[key]));
        }

        if (localStorageItems[key] && decryptedKey === "token") {
          obj.token = JSON.parse(decryptText(localStorageItems[key]));
        }
      } catch (err) {
        console.log("❌ Error decrypting/parsing key:", key, err);
      }
    }
  }

  setUserData(obj.user);
  setUserToken(obj.token);

  return obj;
};

const getToken = () => {
  const localStorageItems = localStorage;

  if (localStorageItems.length !== 0) {
    for (let key in localStorageItems) {
      if (localStorageItems[key] && decryptText(key) === "token") {
        return JSON.parse(decryptText(localStorageItems[key])).access;
      }
    }
  }
};

const getRefreshToken = () => {
  const localStorageItems = localStorage;

  if (localStorageItems.length !== 0) {
    for (let key in localStorageItems) {
      try {
        const decryptedKey = decryptText(key);

        if (localStorageItems[key] && decryptedKey === "token") {
          const parsed = JSON.parse(decryptText(localStorageItems[key]));

          return parsed.refresh;
        }
      } catch (err) {
        console.log("❌ Error reading refresh token:", err);
      }
    }
  }
};

const getUser = async () => {
  const localStorageItems = localStorage;

  if (localStorageItems.length !== 0) {
    for (let key in localStorageItems) {
      if (localStorageItems[key] && decryptText(key) === "user") {
        return JSON.parse(decryptText(localStorageItems[key]));
      }
    }
  }
};

const handleLogout = (setUserData, setUserToken) => {
  const localStorageItems = localStorage;

  if (localStorageItems.length !== 0) {
    for (let key in localStorageItems) {
      try {
        const decryptedKey = decryptText(key);

        if (decryptedKey === "user" || decryptedKey === "token") {
          localStorage.removeItem(key);
        }
      } catch (err) {
        console.log("❌ Error during logout cleanup:", err);
      }
    }

    setUserData({});
    setUserToken({ access: "", refresh: "" });
  }
};

const handleUpdateUser = (setUserData, userData) => {
  const localStorageItems = localStorage;

  for (let key in localStorageItems) {
    if (localStorageItems[key] && decryptText(key) === "user") {
      localStorage.removeItem(key);
    }
  }
  localStorage.setItem(
    encryptText("user"),
    encryptText(JSON.stringify(userData)),
  );
  setUserData(userData);
};

export { handleLogout, getToken, getUser, getRefreshToken, handleUpdateUser };
export default updateUserStates;
